// extracted by mini-css-extract-plugin
module.exports = {"base":"SectionHeading_base__LUDS8"};